"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Submenu = exports.ParentSubmenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@popperjs/core");
var _box = require("@oneloop/box");
var _hooks = require("@oneloop/hooks");
var _excluded = ["children", "setHover", "hover", "placement", "offset"],
  _excluded2 = ["parentId", "childrenId", "variant", "placement", "offset", "arrow"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ParentSubmenu = exports.ParentSubmenu = function ParentSubmenu(_ref) {
  var children = _ref.children,
    setHover = _ref.setHover,
    hover = _ref.hover,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'right' : _ref$placement,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 8 : _ref$offset,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = {
    position: 'absolute',
    width: offset + 'px'
  };
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document !== undefined && document.getElementById(props.id) !== null) {
    var values = document.getElementById(props.id).getBoundingClientRect();
    if (placement === 'right') {
      styles = {
        position: 'fixed',
        width: offset + 'px',
        height: values.height,
        marginLeft: values.width
      };
    } else if (placement === 'bottom') {
      styles = {
        position: 'fixed',
        width: values.width,
        height: offset + 'px',
        marginTop: values.width
      };
    } else if (placement === 'left') {
      styles = {
        position: 'fixed',
        width: offset + 'px',
        height: values.height,
        marginLeft: -offset + 'px'
      };
    } else if (placement === 'top') {
      styles = {
        position: 'fixed',
        width: values.width,
        height: offset + 'px',
        marginTop: -offset + 'px'
      };
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    sx: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({}, props, {
    __css: {
      display: 'flex',
      width: 'fit-content'
    }
  }), children, hover && /*#__PURE__*/_react["default"].createElement("div", {
    id: 'join' + props.id,
    role: 'join' + props.id,
    onMouseOut: function onMouseOut(e) {
      return setHover((0, _hooks.isMouseOutJoin)(e, 'join' + props.id, placement));
    },
    style: styles
  })));
};
var Submenu = exports.Submenu = function Submenu(_ref2) {
  var parentId = _ref2.parentId,
    childrenId = _ref2.childrenId,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'submenu' : _ref2$variant,
    _ref2$placement = _ref2.placement,
    placement = _ref2$placement === void 0 ? 'right' : _ref2$placement,
    _ref2$offset = _ref2.offset,
    offset = _ref2$offset === void 0 ? 8 : _ref2$offset,
    arrow = _ref2.arrow,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var popcorn = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document !== undefined ? document.querySelector('#' + parentId) : null;
  var tooltip = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && document !== undefined ? document.querySelector('#' + childrenId) : null;
  if (popcorn != null && tooltip != null) {
    (0, _core.createPopper)(popcorn, tooltip, {
      placement: placement,
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, offset]
        }
      }]
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    sx: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    tx: "panelSubmenu",
    variant: variant
  }, props, {
    __css: {
      appearance: 'none',
      display: 'flex',
      alignItems: 'flex-start',
      whiteSpace: 'nowrap',
      border: 'none',
      fontFamily: 'Nunito Sans',
      background: '#FFFFFF',
      justifyContent: 'center'
    }
  })), arrow && /*#__PURE__*/_react["default"].createElement(_box.Box, {
    tx: "arrowTooltip",
    variant: placement,
    id: "arrow",
    __css: {
      position: 'absolute',
      background: 'inherit',
      transform: 'translate(-50%)'
    },
    "data-popper-arrow": true
  }));
};